// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".similar-interesting[data-v-3da82f7c]{clear:both}", "",{"version":3,"sources":["webpack://./js.autoload/vueComponents/sliders/SimilarInteresting/SimilarInteresting.vue"],"names":[],"mappings":"AAAA,sCAAqB,UAErB","sourcesContent":[".similar-interesting{clear:both}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
